import Coingecko from "../../assets/logos/coingecko.webp";
import Uniswap from "../../assets/logos/uniswap.png";
import Dextools from "../../assets/logos/dextools.png";

export const medias = [
  [
    Dextools,
    "dextools",
    "https://www.dextools.io/app/uniswap/pair-explorer/0x4d184bf6f805ee839517164d301f0c4e5d25c374",
  ],
  [Coingecko, "coingecko", "https://www.coingecko.com/en/coins/governor-dao"],
  [
    Uniswap,
    "uniswap",
    "https://app.uniswap.org/#/swap?inputCurrency=ETH&outputCurrency=0x515d7e9d75e2b76db60f8a051cd890eba23286bc",
  ],
];
